export class RetailStoreConstants {
    static readonly SLASH_RETAILER_STORE = '/retailer-store';
    static readonly SLASH_RETAILER = '/retailer';
    static readonly SLASH_USER_ID = '/users';
    static readonly SLASH = '/';
    static readonly USERMANAGEMENT = '/user-mgmt/usermanagment';
    static readonly SLASH_CONVERT = '/convert';
    static readonly RETAILER_URL = '/retailers';
    static readonly SEARCH_URL = '?searchby=';
    static readonly SORTBY = '?sortby=';
    static readonly SORT_TYPE = '&sorttype=';
    static readonly DOWNLOAD = 'download';
    static readonly PAGE_NUMBER = '?pagenumber';
    static readonly EQUALS = '=';
    static readonly SEARCH_BY = 'searchby';
    static readonly RETAIL_USER_ROLE = 'retailHQUser';
    static readonly NAME_SORT = 'retailername';
    static readonly RETAILERID_SORT = 'retailerid';
    static readonly CREATED_SORT = 'createdtime';
    static readonly UPDATED_SORT = 'updatedtime';
    static readonly EMPTY_VALUE = '';
    static readonly ASCENDING_ORDER = 'asc';
    static readonly DESCENDING_ORDER = 'desc';
    static readonly SORT_BY = 'sortby';
    static readonly SORT_TYPES = 'sorttype';
    static readonly COMPRXT = 'comprxt';
    static readonly CONNECTED_RETAILHQS = $localize`:@@retail-hq.connected-retailhqs:Connected Retail HQs`;
    static readonly UNCONNECTED_RETAILHQS = $localize`:@@retail-hq.unconnected-users:Unconnected Users`;
    static readonly RETAILHQ_UNCONNECTED_NOTE = $localize`:@@retail-hq.unconnected-settings-note:Note: These settings are applicable to all unconnected users`;
    static readonly RETAILHQ_UNCONNECTED_APPLICABLE_NOTE = $localize`:@@retail-hq.unconnected-applicable-note:Note: The following flags are applicable to all unconnected users`;
    static readonly AALOW_PRICE_SUPRESSION = $localize`:@@retail-hq.allow-price-suppression:Allow Price Suppression`;
    static readonly DELETE_STORES = '/deleteStores';
    static readonly CONFIRM_DELETE_STORES = '/confirmDeleteStores';
    static readonly HOME_PAGE = '/homePage';
}
